import React from 'react';
import { type MyAccountSettings } from '../../api/types.js';
import { InputField } from './Field.js';
import SaveBar from './SaveBar.js';
import { useEditable } from './useEditable.js';
import { useTranslation } from '../../i18n/useTranslation.js';

interface Props {
  value: MyAccountSettings;
  onSave: (next: MyAccountSettings) => Promise<void>;
  onSignOutAll: () => void;
}

function MyAccountTab({ value, onSave, onSignOutAll }: Props) {
  const { t } = useTranslation();
  const { draft, set, dirty, saving, reset, save } = useEditable(value, onSave);

  return (
    <div className="sp on">
      <div className="sp-title">{t('myAccount.title')}</div>
      <div className="sp-subtitle">{t('myAccount.subtitle')}</div>

      <div className="sg">
        <div className="sg-title">{t('myAccount.profile')}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
          <div className="um-avatar" style={{ width: 56, height: 56, fontSize: 22 }}>
            {(draft.displayName[0] || 'R').toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>{draft.displayName}</div>
            <div style={{ fontSize: 11, color: 'var(--t3)', fontFamily: 'var(--mono)' }}>ID: {draft.analystId}</div>
          </div>
        </div>
        <div className="sg-grid">
          <InputField
            label={t('myAccount.displayName')}
            value={draft.displayName}
            onChange={(v) => set('displayName', v)}
          />
          <InputField label={t('myAccount.analystId')} value={draft.analystId} readOnly onChange={() => {}} />
          <InputField label={t('myAccount.email')} type="email" value={draft.email} onChange={(v) => set('email', v)} />
          <InputField label={t('myAccount.phone')} type="tel" value={draft.phone} onChange={(v) => set('phone', v)} />
        </div>
      </div>

      <div className="sg">
        <div className="sg-title">{t('myAccount.security')}</div>
        <div className="sg-grid">
          <InputField
            label={t('myAccount.currentPassphrase')}
            type="password"
            value=""
            onChange={() => {}}
            hint={t('myAccount.currentPassphraseHint')}
          />
          <InputField
            label={t('myAccount.newPassphrase')}
            type="password"
            value=""
            onChange={() => {}}
            hint={t('myAccount.newPassphraseHint')}
          />
          <InputField label={t('myAccount.confirmPassphrase')} type="password" value="" onChange={() => {}} />
        </div>
        <div
          className="status-row"
          style={{
            background: 'var(--gnd)',
            border: '1px solid rgba(34,197,94,.25)',
            borderRadius: 6,
            padding: '8px 12px',
            marginTop: 10,
          }}
        >
          <span className="status-light online" />
          <span className="status-name" style={{ color: 'var(--grn)' }}>
            {t('myAccount.mfaEnabled')}
          </span>
          <span className="status-meta">{t('myAccount.lastAuth')}</span>
        </div>
        <button
          className="btn-cancel"
          style={{ marginTop: 12, color: 'var(--red)', borderColor: 'rgba(239,68,68,.35)' }}
          onClick={onSignOutAll}
        >
          {t('myAccount.signOutAll')}
        </button>
      </div>

      <SaveBar dirty={dirty} saving={saving} onCancel={reset} onSave={save} />
    </div>
  );
}

export default MyAccountTab;
